import React from "react";
import CardSkeleton from "../post-inspection-marketplace-card/skeleton";
import styles from "./skeleton.css";

export default function Skeleton() {
    return (
        <>
            <div styleName="styles.carInfo">
                <div styleName="styles.carImage">
                    <div styleName="styles.image" className="shimmer" />
                </div>
                <div styleName="styles.details">

                    <div styleName="styles.regNo" className="shimmer" />
                </div>
            </div>
            <CardSkeleton />
            <CardSkeleton />
        </>
    );
}
